import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6985cd77921dc90014e7ebf6_1781439199936_0551836a/website_project/src/app/legal-news/page.tsx");
